import { httpClient } from '@/shared/api/httpClient';
import { endpoints } from '@/shared/api/endpoints';
import type { LeadDto, UpsertLeadNoteRequest } from '@/shared/types/domain';

export const leadsApi = {
  getByExhibitor: (exhibitorId: string, signal?: AbortSignal) =>
    httpClient.get<LeadDto[]>(endpoints.leads.byExhibitor(exhibitorId), signal),

  upsertNotes: (scanId: string, data: UpsertLeadNoteRequest) =>
    httpClient.put<LeadDto>(endpoints.leads.upsertNotes(scanId), data),

  exportMineCsv: () => httpClient.downloadFile(endpoints.leads.exportMineCsv),
  exportMineXlsx: () => httpClient.downloadFile(endpoints.leads.exportMineXlsx),
  exportTeamCsv: (exhibitorId: string) => httpClient.downloadFile(endpoints.leads.exportTeamCsv(exhibitorId)),
  exportTeamXlsx: (exhibitorId: string) => httpClient.downloadFile(endpoints.leads.exportTeamXlsx(exhibitorId))
};